import { gql } from '@apollo/client';
// import { CORE_TOOL_CATALOG_FIELDS } from './tool-catalog';

const CORE_TOOL_TRANSFER_FIELDS = gql`
  fragment ToolTransferCoreFields on ToolTransfer {
    id
    toolTransferNumber
    comment
    createdBy
    createdDate
    createdByUser {
      id
      bun
      firstName
      lastName
      employee {
        id
        imageUrl
      }
    }
    sourceToolRoom {
      id
      name
      barCode
    }
    destinationToolRoom {
      id
      barCode
      name
    }
    projectId
  }
`;
export const CREATE_TOOL_TRANSFER = gql`
  ${CORE_TOOL_TRANSFER_FIELDS}
  mutation CreateToolTransfer($createToolTransferInput: CreateToolTransferInput!) {
    createToolTransfer(createToolTransferInput: $createToolTransferInput) {
      toolTransfer {
        ...ToolTransferCoreFields
      }
      error
    }
  }
`;

export const UPDATE_TOOL_TRANSFER = gql`
  ${CORE_TOOL_TRANSFER_FIELDS}
  mutation updateToolTransfer($updateToolTransferInput: UpdateToolTransferInput!) {
    updateToolTransfer(updateToolTransferInput: $updateToolTransferInput) {
      toolTransfer {
        ...ToolTransferCoreFields
      }
    }
  }
`;

export const SEARCH_TOOL_TRANSFER = gql`
  query SearchToolTransfers($searchInput: SearchInput!) {
    searchToolTransfers(searchInput: $searchInput) {
      items {
        id
        toolTransferNumber
        comment
        createdBy
        createdDate
        stats {
          id
          consumables
          tools
        }
        createdByUser {
          id
          bun
          firstName
          lastName
          employee {
            id
            imageUrl
          }
        }
        sourceToolRoom {
          id
          name
          barCode
        }
        destinationToolRoom {
          id
          barCode
          name
        }
        projectId
      }
    }
  }
`;

export const GET_TOOL_TRANSFER_BY_ID = gql`
  query toolTransferById($toolTransferByIdId: ID!) {
    toolTransferById(id: $toolTransferByIdId) {
      id
      toolTransferNumber
      comment
      createdDate
      stats {
        id
        consumables
        tools
      }
      createdByUser {
        id
        bun
        firstName
        lastName
        employee {
          id
          imageUrl
        }
      }
      sourceToolRoom {
        id
        name
        barCode
      }
      destinationToolRoom {
        id
        barCode
        name
      }
      projectId
      toolTransferItems {
        id
        requestedQuantity
        toolInventory {
          id
          barCode
          barCodeId
          description
          isSerialized
          onHandCount
          toolCatalog {
            id
            name
            bscnPartNumber
            inventoryType
            toolCatalogImageUrl
            uomId
            uom {
              id
              abbreviation
            }
            toolCategory {
              id
              name
            }
          }
        }
      }
    }
  }
`;
